import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import useApi from "../../hook/useApi";
import { toast } from "react-toastify";
import { copyToClipboard, formatDateInAMPM, trimAddress } from "../../utils/helper";
import { IoCopyOutline } from "react-icons/io5";
import { AIRDROP_STATUS } from "../../utils/constant";

const AirdropTxViewLayer = () => {
     const [loading, setLoading] = useState(false);
     const [airdrop, setAirdrop] = useState("");
     const { id } = useParams();
     const { AsyncGetApiCall } = useApi();

     const fetchAirdrop = async () => {
          setLoading(true);

          const result = await AsyncGetApiCall(`/airdrop/get/${id}`);

          if (result.errors) {
               toast.error(result.errors[0]);
          } else if (result.success) {
               setAirdrop(result?.data);
          }

          setLoading(false);
     };

     useEffect(() => {
          fetchAirdrop();
     }, []);

     return (
          <>
               {loading && <Loader />}
               <div className="row gy-4">
                    <div className={`col-lg-4 w-50`}>
                         <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
                              <div className="pb-24 ms-16 mb-24 me-16 mt-100">
                                   <div className="mt-24">
                                        <h6 className="text-xl mb-16">Airdrop Transaction Info</h6>
                                        <ul>
                                             <li className="d-flex align-items-center gap-2 mt-4">
                                                  <span className="w-30 text-md fw-semibold text-primary-light">
                                                       Merkle Root
                                                  </span>
                                                  <span>:</span>
                                                  <span className="w-70 text-secondary-light fw-medium">
                                                       {trimAddress(airdrop?.merkleRoot, 6, 6)}
                                                       <button
                                                            onClick={() => copyToClipboard(airdrop?.merkleRoot)}
                                                            className="ms-3 p-0 border-0 bg-transparent"
                                                            style={{ lineHeight: 1 }}
                                                       >
                                                            <IoCopyOutline />
                                                       </button>
                                                  </span>
                                             </li>
                                             <li className="d-flex align-items-center gap-2 mt-4">
                                                  <span className="w-30 text-md fw-semibold text-primary-light">
                                                       Receiver
                                                  </span>
                                                  <span>:</span>
                                                  <span className="w-70 text-secondary-light fw-medium">
                                                       {trimAddress(airdrop?.receiver, 6, 6)}
                                                       <button
                                                            onClick={() => copyToClipboard(airdrop?.receiver)}
                                                            className="ms-3 p-0 border-0 bg-transparent"
                                                            style={{ lineHeight: 1 }}
                                                       >
                                                            <IoCopyOutline />
                                                       </button>
                                                  </span>
                                             </li>
                                             <li className="d-flex align-items-center gap-2 mt-4">
                                                  <span className="w-30 text-md fw-semibold text-primary-light">
                                                       Quantity
                                                  </span>
                                                  <span>:</span>
                                                  <span className="w-70 text-secondary-light fw-medium">
                                                       {airdrop?.quantity || "N/A"}
                                                  </span>
                                             </li>
                                             <li className="d-flex align-items-center gap-2 mt-4">
                                                  <span className="w-30 text-md fw-semibold text-primary-light">
                                                       Proofs
                                                  </span>
                                                  <span className="me-2">:</span>
                                                  <div className="d-flex align-items-center w-70 text-secondary-light fw-medium ">
                                                       {airdrop?.proofs && airdrop?.proofs.length > 0 ? (
                                                            <ul className="list-unstyled">
                                                                 {airdrop?.proofs.map((proof, index) => (
                                                                      <li key={index} className="d-flex align-items-center gap-2 mb-2 border p-4 radius-4">
                                                                           <span>{trimAddress(proof, 6, 4)}</span>
                                                                           <button
                                                                                onClick={() => copyToClipboard(proof)}
                                                                                className="ms-3 p-0 border-0 bg-transparent"
                                                                                style={{ lineHeight: 1 }}
                                                                           >
                                                                                <IoCopyOutline />
                                                                           </button>
                                                                      </li>
                                                                 ))}
                                                            </ul>
                                                       ) : (
                                                            <span>N/A</span>
                                                       )}
                                                  </div>
                                             </li>
                                             <li className="d-flex align-items-center gap-2 mt-6">
                                                  <span className="w-30 text-md fw-semibold text-primary-light">
                                                       Token Address
                                                  </span>
                                                  <span>:</span>
                                                  <span className="w-70 text-secondary-light fw-medium">
                                                       {trimAddress(airdrop?.token, 6, 6)}
                                                       <button
                                                            onClick={() => copyToClipboard(airdrop?.token)}
                                                            className="ms-3 p-0 border-0 bg-transparent"
                                                            style={{ lineHeight: 1 }}
                                                       >
                                                            <IoCopyOutline />
                                                       </button>
                                                  </span>
                                             </li>
                                             <li className="d-flex align-items-center gap-2 mt-6">
                                                  <span className="w-30 text-md fw-semibold text-primary-light">
                                                       Status
                                                  </span>
                                                  <span>:</span>
                                                  <span
                                                       className={`badge ${airdrop.status === AIRDROP_STATUS.SUCCESS
                                                            ? 'bg-success-100 text-success-600'
                                                            : airdrop.status === AIRDROP_STATUS.PENDING
                                                                 ? 'bg-warning-100 text-warning-600'
                                                                 : airdrop.status === AIRDROP_STATUS.FAILED
                                                                      ? 'bg-danger-100 text-danger-600'
                                                                      : 'background-gray-100'
                                                            } text-sm py-4 px-10 radius-4`}
                                                  >
                                                       {airdrop?.status?.toUpperCase() || "N/A"}
                                                  </span>
                                             </li>
                                             <li className="d-flex align-items-center gap-2 mt-6">
                                                  <span className="w-30 text-md fw-semibold text-primary-light">
                                                       Date
                                                  </span>
                                                  <span>:</span>
                                                  <span className="w-70 text-secondary-light fw-medium">
                                                       {formatDateInAMPM(airdrop?.createdAt)}

                                                  </span>
                                             </li>
                                        </ul>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div >
          </>
     );
};

export default AirdropTxViewLayer;
